import DossierRepository from "./dossierRepository";
import FamilyRepository from "./familyRepository";
import GeographyRepository from "./geographyRepository";
import NbeRepository from "./nbeRepository";
import NotificationsRepository from "./notificationsRepository";
import OpdrachtRepository from "./opdrachtRepository";
import UserRepository from "./userRepository";
import {moduleRepository} from "./moduleRepository";
import {photoRepository} from "./photoRepository";

const repositories = {
  dossier: DossierRepository,
  family: FamilyRepository,
  geography: GeographyRepository,
  module: moduleRepository,
  nbe: NbeRepository,
  notifications: NotificationsRepository,
  opdracht: OpdrachtRepository,
  photo: photoRepository,
  user: UserRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
